import {
  IconButton,
  Typography,
  ButtonBase,
  Menu,
  ListItem,
  ListItemIcon,
  Hidden
} from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import ImportContactsOutlinedIcon from '@material-ui/icons/ImportContactsOutlined'
import MoreIcon from '@material-ui/icons/MoreVert'
import ViewIcon from '@material-ui/icons/RemoveRedEye'
import React, { useState } from 'react'

import CheckStatusModal from '../../components/CheckStatusModal'
import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../helpers/date'
import { addCommaToPrice } from '../../helpers/numbers'
import { persianRegex } from '../../helpers/regex'
import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate, lang } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import bookRoleManagement from '../../staticRoleManagement/bookRoleManagement'
import { BookingDetails } from '../../types/booking'
import StatusBox from './StatusBox'
import useStyles from './styles/BookingsListTableRow.styles'

interface BookingsListTableRowProps {
  data: BookingDetails
  hasAccessToViewBookingDetails: boolean | undefined
  hasAccessToEditBookingDetails: boolean | undefined
  isOdd: boolean
}

export const BookingsListTableRow: React.FC<BookingsListTableRowProps> = ({
  data,
  hasAccessToViewBookingDetails,
  hasAccessToEditBookingDetails,
  isOdd
}) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)

  const isPersianChannelName = persianRegex.test(data.sourceName)
  const isPersianBookerName = persianRegex.test(data.bookerName)
  const [isOpencheckStatusModal, setIsOpencheckStatusModal] = useState(false)
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault()
    setAnchorEl(null)
  }
  const hasAccessToCheckStatus = bookRoleManagement
    .find((item) => item.route === '/booking/list/:reserveNumber/view')
    ?.sections?.CHECK_STATUS.rolesListWithReadAccess?.includes(
      getRoleFromStorage()
    )

  const CRSStatusIsPrimitive = data.crsStatus === 'Primitive'

  return (
    <>
      <ButtonBase
        className={[classes.tableRow, isOdd ? classes.tableRowOdd : ''].join(
          ' '
        )}
        component={LocalizedLink}
        disabled={CRSStatusIsPrimitive}
        to={`/booking/list/${data.bookingNumber}/view`}>
        <div>
          <Typography variant="body1" className={classes.textFontFirstElement}>
            {lang === 'fa'
              ? gregorianToJalaaliWithHourMinuteAndSecond(data.bookingDate)
              : data.bookingDate}
          </Typography>
        </div>
        <div>
          <Typography variant="body1" className={classes.textFont}>
            {data.displayBookingNumber}
          </Typography>
        </div>
        <div>
          <Typography variant="body1" className={classes.textFont}>
            {data.providerName}
          </Typography>
        </div>
        <div>
          <Typography variant="body1" className={classes.textFont}>
            {data.propertyName}
          </Typography>
        </div>
        <div>
          <Typography
            className={classes.textFont}
            variant="body1"
            style={
              isPersianChannelName ? { fontFamily: 'IranSans' } : undefined
            }>
            {data.sourceName}
          </Typography>
        </div>
        <div>
          <Typography
            className={classes.textFont}
            variant="body1"
            style={
              isPersianBookerName ? { fontFamily: 'IranSans' } : undefined
            }>
            {data.bookerName}
          </Typography>
        </div>
        <Hidden lgDown>
          <Typography variant="body1" className={classes.textFont}>
            {data.numberOfRooms}
          </Typography>
        </Hidden>
        <Hidden lgDown>
          <Typography variant="body1" className={classes.textFont}>
            {`${addCommaToPrice(data.totalPrice)} ${getTranslate(
              data.currency || ''
            )}`}
          </Typography>
        </Hidden>
        <div className={classes.cell}>
          <StatusBox status={data.crsStatus} />
        </div>
        <div className={classes.cell}>
          <StatusBox status={data.pmsStatus} />
        </div>
        <div>
          <IconButton onClick={handleClick}>
            <MoreIcon />
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            dir={lang === 'fa' ? 'rtl' : 'ltr'}
            open={Boolean(anchorEl)}
            onClose={handleClose}>
            <ListItem
              className={classes.cursor}
              disabled={!hasAccessToViewBookingDetails || CRSStatusIsPrimitive}
              button
              component={LocalizedLink}
              to={`/booking/list/${data.bookingNumber}/view`}>
              <ListItemIcon>
                <ViewIcon fontSize="small" />
              </ListItemIcon>
              <Typography variant="inherit">{getTranslate('View')}</Typography>
            </ListItem>
            <ListItem
              disabled={!hasAccessToEditBookingDetails}
              button
              component={LocalizedLink}
              to={`/booking/list/${data.bookingNumber}/edit`}>
              <ListItemIcon>
                <EditIcon fontSize="small" />
              </ListItemIcon>
              <Typography variant="inherit">{getTranslate('Edit')}</Typography>
            </ListItem>
            {hasAccessToCheckStatus && (
              <ListItem
                button
                onClick={(event) => {
                  event.stopPropagation()
                  setIsOpencheckStatusModal(!isOpencheckStatusModal)
                }}>
                <ListItemIcon>
                  <ImportContactsOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <Typography variant="inherit">
                  {getTranslate('Check Status')}
                </Typography>
              </ListItem>
            )}
          </Menu>
        </div>
      </ButtonBase>
      {isOpencheckStatusModal && (
        <CheckStatusModal
          isOpen={isOpencheckStatusModal}
          onClose={() => setIsOpencheckStatusModal(false)}
          reservationNumber={data.bookingNumber.toString()}
        />
      )}
    </>
  )
}
